// Croqui: `components/Amount.tsx`.
//
// O croqui recebe `v: string` porque é maquete. Aqui o valor entra em CENTAVOS e a
// formatação é de `lib/money.ts` (`spec/17` §4.6 é decisão fechada; `spec/24` §3 manda
// tratar a maquete como o lado que cede). Registrado em "Questões abertas" da WEB-50.

import { cn } from '../../lib/cn.ts';
import { formatCents } from '../../lib/money.ts';
import { INK_TEXT, type Ink } from './ink.ts';

const SIZE = {
  10: 'text-10',
  11: 'text-11',
  12: 'text-12',
  13: 'text-13',
  14: 'text-14',
  16: 'text-16',
  18: 'text-18',
} as const;

// 700 continua na API e desenha 600: o sistema para no semibold (WEB-133).
const WEIGHT = {
  400: 'font-normal',
  500: 'font-medium',
  600: 'font-semibold',
  700: 'font-semibold',
};

/** Valor monetário inline, tabular, sem quebra. Em tabela, KV e mini-KPI. */
export function Amount({
  cents,
  ink = 'auto',
  size = 14,
  weight = 600,
  sign = 'auto',
  withSymbol = true,
  className,
}: {
  cents: number;
  /** `auto` pinta o negativo de `danger`; `gold` é o dinheiro-herói. */
  ink?: Ink | 'auto';
  size?: keyof typeof SIZE;
  weight?: keyof typeof WEIGHT;
  /**
   * `auto`: só o negativo ganha sinal (o `−` de `formatCents`). `ledger`: extrato, onde a
   * direção do lançamento é a informação, o positivo sai com `+` explícito.
   */
  sign?: 'auto' | 'ledger';
  withSymbol?: boolean;
  className?: string;
}) {
  const resolved: Ink = ink === 'auto' ? (cents < 0 ? 'danger' : 'text') : ink;
  return (
    <span
      className={cn(
        'whitespace-nowrap font-num tabular-nums',
        SIZE[size],
        WEIGHT[weight],
        INK_TEXT[resolved],
        className,
      )}
    >
      {sign === 'ledger' && cents > 0 ? '+' : ''}
      {formatCents(cents, { withSymbol })}
    </span>
  );
}
